import { Injectable } from '@angular/core';

import { Action, Selector, State, StateContext } from '@ngxs/store';

import { LoadingActions } from './loading.actions';

export interface LoadingStateModel {
  loading: boolean;
  commandLoading: boolean;
}
@State<LoadingStateModel>({
  name: 'loading',
  defaults: {
    loading: false,
    commandLoading: false,
  },
})
@Injectable()
export class LoadingState {
  @Selector()
  static loading(state: LoadingStateModel) {
    return state.loading;
  }
  @Selector()
  static commandLoading(state: LoadingStateModel) {
    return state.commandLoading;
  }
  @Action(LoadingActions.SetLoading)
  startLoading(
    { patchState }: StateContext<LoadingStateModel>,
    { loading }: LoadingActions.SetLoading,
  ) {
    patchState({
      loading,
    });
  }
  @Action(LoadingActions.SetCommandLoading)
  startCommandLoading(
    { patchState }: StateContext<LoadingStateModel>,
    { commandLoading }: LoadingActions.SetCommandLoading,
  ) {
    patchState({
      commandLoading,
    });
  }
}
